import React from 'react';
import style from './Tile.module.css';
import { useNavigate } from 'react-router-dom';

const Tile = ({ report, userId }) => {
  const navigate = useNavigate();

  const handleReport = (report, userId) => {
    navigate(`/submission/${report._id}/${userId}`);
  };

  return (
    <div onClick={() => handleReport(report, userId)} className={style.Tile}>
      <h2>{report.report.title}</h2>
      <p>{`Submited for ${report.program} program`}</p>
      <div className={style.Lower}>
        <p>{report.severity}</p>
        <p>{report.status}</p>
      </div>
      <div className={style.Line}></div>
    </div>
  );
};

export default Tile;
